import type { TutorBillingRow } from './interfaces'

import { TutorBillingFlag } from './enums'
import { TUTOR_BILLING_DOT_FLAGS, TUTOR_BILLING_FLAG_LABELS, TUTOR_BILLING_FLAGS } from '../config/tutor-billing'

interface TutorBillingStatusDot {
  flag: TutorBillingFlag
  label: string
  isOn: boolean
}

interface TutorBillingStatusCardRow extends TutorBillingStatusDot {
  isIssue: boolean
  stateText: string
}

interface TutorBillingStatusFlagsOptions {
  row: ComputedRef<TutorBillingRow>
}

interface TutorBillingStatusFlagsReturn {
  dots: ComputedRef<TutorBillingStatusDot[]>
  hasIssues: ComputedRef<boolean>
  cardRows: ComputedRef<TutorBillingStatusCardRow[]>
  triggerLabel: ComputedRef<string>
}

export const useTutorBillingStatusFlags = ({ row }: TutorBillingStatusFlagsOptions): TutorBillingStatusFlagsReturn => {
  const dots = computed<TutorBillingStatusDot[]>(() => TUTOR_BILLING_DOT_FLAGS.map(flag => ({
    flag,
    label: TUTOR_BILLING_FLAG_LABELS[flag],
    isOn: row.value[flag],
  })))

  const hasIssues = computed<boolean>(() => row.value[TutorBillingFlag.IssuesDetected])

  const cardRows = computed<TutorBillingStatusCardRow[]>(() => TUTOR_BILLING_FLAGS.map(flag => ({
    flag,
    label: TUTOR_BILLING_FLAG_LABELS[flag],
    isOn: row.value[flag],
    isIssue: flag === TutorBillingFlag.IssuesDetected,
    stateText: row.value[flag] ? 'On' : 'Off',
  })))

  const triggerLabel = computed<string>(() => {
    const values = cardRows.value.map(cardRow => `${cardRow.label} ${cardRow.stateText.toLowerCase()}`)
    return `Legal statuses: ${values.join(', ')}`
  })

  return {
    dots,
    hasIssues,
    cardRows,
    triggerLabel,
  }
}
